import { AppLayout } from 'layouts';
import { useState } from 'react';
import { ChatCreate, ChatCreateLayout } from 'features/chat';
import {
  useChatroomsSearchParams,
  useCreateChatUserFromLocation,
  useNavigateToChat,
  useNavigateToCreateChat,
  useRedirectToChatroom,
} from '../hooks';

const PageCreateChat = () => {
  const navigateToChat = useNavigateToChat();
  const navigateToCreateChat = useNavigateToCreateChat();
  const searchParamsOptions = useChatroomsSearchParams();
  const redirectToChatroom = useRedirectToChatroom();
  const { userToChat } = useCreateChatUserFromLocation();
  const [creatingChatroomId, setCreatingChatroomId] = useState<string>();

  return (
    <AppLayout fitCenterContent>
      <ChatCreateLayout
        onChatDeleted={navigateToChat}
        onChatRoomClicked={redirectToChatroom}
        onCreateChatClicked={navigateToCreateChat}
        searchParamsOptions={searchParamsOptions}
        selectedChatroomId={creatingChatroomId}
      >
        <ChatCreate
          key={userToChat?.id}
          onChatroomCreated={setCreatingChatroomId}
          onClose={navigateToChat}
          onCreated={redirectToChatroom}
          userToChat={userToChat}
        />
      </ChatCreateLayout>
    </AppLayout>
  );
};

export default PageCreateChat;
